import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
   * L'Oscar London BE own system
   */
const factory = function factory({ window, document, thn }) {
    let refreshPrice;
    let updatePriceOnAddCartEvent = null;
    const hotelIdsDictionary = {
        1157148: '816',
    };
    const languagesDictionary = {
        en: 'en-US',
    };
    const isVersion2 = !!window.location.pathname.match(/booking/);
    function getVisiblePrices(selector) {
        return Array.from(document.querySelectorAll(selector))
            .filter(price => thn.isVisible(price))
            .map(price => thn.parseNumber(price.textContent))
            .filter((value) => typeof value !== 'undefined');
    }
    function getCommonDates() {
        const isFrenchLanguage = thn.data.language === 'fr';
        const dateBeginEl = document.querySelector('input[data-bind*=checkIn]')?.value
            || document.querySelector('span[data-bind*=checkIn]')?.textContent?.replace(/\./g, '') || '';
        const dateEndEl = document.querySelector('input[data-bind*=checkOut]')?.value
            || document.querySelector('span[data-bind*=checkOut]')?.textContent?.replace(/\./g, '') || '';
        const dateBegin = (isFrenchLanguage && !isVersion2) ? dateBeginEl?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') : translateDate(dateBeginEl);
        const dateEnd = (isFrenchLanguage && !isVersion2) ? dateEndEl?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') : translateDate(dateEndEl);
        return dateBegin && dateEnd ? [dateBegin, dateEnd] : null;
    }
    return {
        generateSearchUrl(ctx) {
            // Desktop: https://www.loscarlondon.com/gad/?currency=USD&checkin=2025-02-28&checkout=2025-03-01&rooms=1&adults=2&couponCode=cocolala
            // Mobile: https://www.loscarlondon.com/booking/?view=2&apikey=&hotel_id=816&ci=2024-10-31&co=2024-11-01&board=RoomRate&lang=en-US&currency=GBP&r=3
            const url = new URL(ctx.baseUrl);
            const validUrl = url.pathname.match(/booking|check-rates/);
            const isMobile = thn.data.media.name === 'mobile';
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            if (isMobile) { // Mobile
                // Replace path to booking
                url.pathname = url.pathname.replace(/gad|check-rates/, 'booking');
                // Remove desktop params if exist
                url.searchParams.delete('currency');
                url.searchParams.delete('language');
                url.searchParams.delete('checkin');
                url.searchParams.delete('checkout');
                url.searchParams.delete('rooms');
                url.searchParams.delete('adults');
                url.searchParams.delete('children');
                url.searchParams.delete('infants');
                url.searchParams.delete('couponCode');
                // Set new params
                url.searchParams.set('hotel_id', hotelIdsDictionary[thn.data.propertyId]);
                url.searchParams.set('view', '2');
                url.searchParams.set('ci', '[date_begin]');
                url.searchParams.set('co', '[date_end]');
                url.searchParams.set('board', 'RoomRate');
                url.searchParams.set('lang', languagesDictionary[ctx.data.language]);
                url.searchParams.set('currency', ctx.data.currency);
                url.searchParams.set('r', '[adults]');
            }
            else { // Desktop
                // Replace path to gad
                url.pathname = url.pathname.replace(/booking|check-rates/, 'gad');
                // Remove mobile params if exist
                url.searchParams.delete('couponCode');
                url.searchParams.delete('view');
                url.searchParams.delete('apikey');
                url.searchParams.delete('hotel_id');
                url.searchParams.delete('ci');
                url.searchParams.delete('co');
                url.searchParams.delete('board');
                url.searchParams.delete('lang');
                // Set new params
                url.searchParams.set('currency', '[currency]');
                url.searchParams.set('language', '[language]');
                url.searchParams.set('checkin', '[date_begin]');
                url.searchParams.set('checkout', '[date_end]');
                url.searchParams.set('rooms', '1');
                url.searchParams.set('adults', '[adults]');
                url.hash = '';
                // Calculate children and infants from childrenAges
                const children = ctx.data.roomsDispo?.[0]?.childrenAges?.filter(age => age >= 3)?.length || 0;
                const infants = ctx.data.roomsDispo?.[0]?.childrenAges?.filter(age => age < 3)?.length || 0;
                url.searchParams.set('children', children.toString());
                url.searchParams.set('infants', infants.toString());
            }
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        boot() {
            const bodyElm = document.body; // refresh page on V1
            const refreshPage = thn.debounce(() => {
                thn.pageCheck();
            }, 800);
            const containerSteps = document.querySelector('.bookwize-steps');
            thn.observeDom(bodyElm, refreshPage, {
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(bodyElm, refreshPage);
            });
            if (containerSteps) {
                thn.observeDom(containerSteps, refreshPage, {
                    childList: true,
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(containerSteps, refreshPage);
                });
            }
        },
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 800),
        priceObserveDom(ctx) {
            // Element to refresh price v2 when occupancy and dates change
            const containerRooms = document.querySelector('#Loader');
            const containerRoomsSelected = document.querySelector('.bookwize-sidebar-row [data-bind*=requestedRooms]');
            refreshPrice = thn.debounce(() => {
                ctx.widget.refresh().catch(() => { });
            }, 800);
            if (containerRooms) {
                thn.observeDom(containerRooms, refreshPrice, {
                    attributes: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(containerRooms, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
            // Refresh price v2 when a room is selected and we come back
            if (containerRoomsSelected) {
                thn.observeDom(containerRoomsSelected, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['data-bind'],
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(containerRoomsSelected, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
            if (!updatePriceOnAddCartEvent) {
                // Refresh price v2 when selecting a room
                updatePriceOnAddCartEvent = (data) => {
                    if (!data.message)
                        return;
                    const message = data.message;
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    const gtmElement = message['gtm.element'];
                    const isCurrencyButton = !!gtmElement?.attributes?.['data-bind']?.textContent?.match(/text: code/) || false;
                    if (message?.[1] === 'add_to_cart' || isCurrencyButton) {
                        ctx.widget.refresh().catch(() => { });
                    }
                };
                thn.bus.on('dataLayer:push', updatePriceOnAddCartEvent);
                thn.pageUnload(() => {
                    if (updatePriceOnAddCartEvent) {
                        thn.bus.detach('dataLayer:push', updatePriceOnAddCartEvent);
                        updatePriceOnAddCartEvent = null;
                    }
                });
            }
        },
        priceParseData_v1() {
            // Dates
            const [dateBegin, dateEnd] = getCommonDates() || [];
            if (!dateBegin || !dateEnd || isVersion2) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd);
            // Adults, children and occupancy
            const occupancyArray = document.querySelectorAll('span.hp-guests-select');
            const adults = thn.parseNumber(occupancyArray[0]?.textContent) ?? 2;
            const children = thn.parseNumber(occupancyArray[1]?.textContent) ?? 0;
            const infants = thn.parseNumber(occupancyArray[2]?.textContent) ?? 0;
            const roomInfo = {
                adults,
                children: children + infants,
                childrenAges: [],
            };
            for (let i = 1; i <= roomInfo.children; i += 1) {
                const age = children >= i ? 10 : 1;
                roomInfo.childrenAges.push(age);
            }
            // Price and currency
            const ratesPrices = getVisiblePrices('[data-bind*=showPrices] .hp-price');
            const currency = document.querySelector('[data-bind*=currency]')?.textContent || '';
            const noAvailability = !!document.querySelector('.check-rates-container [data-hotel-availability]');
            if (!thn.empty(ratesPrices) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    price: Math.min(...ratesPrices) / nights,
                    currency,
                };
            }
            if (noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children: roomInfo.children,
                    currency,
                    noRooms: true,
                };
            }
            return null;
        },
        priceParseData_v2() {
            // Dates
            const [dateBegin, dateEnd] = getCommonDates() || [];
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd);
            const multipleRoomElms = Array.from(document.querySelectorAll('div[data-bind*= requestedRooms] .bookwize-sidebar-inner'));
            const roomNumber = document.querySelectorAll('.bookwize-selected-rooms-inline').length;
            const occupancyArray = multipleRoomElms[roomNumber]?.querySelectorAll('.bookwize-guest-inner .bookwize-guest-length');
            const adults = thn.parseNumber(occupancyArray[0]?.textContent) ?? 2;
            const children = thn.parseNumber(occupancyArray[1]?.textContent) ?? 0;
            const infants = thn.parseNumber(occupancyArray[2]?.textContent) ?? 0;
            const roomInfo = {
                adults,
                children: children + infants,
                childrenAges: [],
            };
            for (let i = 1; i <= roomInfo.children; i += 1) {
                const age = children >= i ? 10 : 1;
                roomInfo.childrenAges.push(age);
            }
            const ratesPrices = getVisiblePrices('.bookwize-room-rateplan-list .bookwize-room-rateplan-list-row [data-bind*=price]');
            const currency = document.querySelector('[data-bind*=currency]')?.textContent || '';
            if (!thn.empty(ratesPrices) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    price: Math.min(...ratesPrices) / nights,
                    currency,
                };
            }
            if (thn.empty(ratesPrices)) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children: roomInfo.children,
                    currency,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const pinIdBookingV1 = document.querySelector('.hp-reservation .hp-form-row [data-bind*= id]')?.textContent;
            const pinIdBookingElmsV2 = Array.from(document.querySelectorAll('.bookwize-step4-inner .bookwize-step4-text[data-bind*= id]'));
            if (pinIdBookingV1) {
                // booking data trough price v1
                const dateBegin = document.querySelector('.hp-reservation .hp-form-row [data-bind*=checkIn]')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                const dateEnd = document.querySelector('.hp-reservation .hp-form-row [data-bind*=checkOut]')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                const adults = thn.parseNumber(document.querySelector('.hp-reservation-rooms [data-bind*= adults]')?.textContent);
                const children = thn.parseNumber(document.querySelector('.hp-reservation-rooms [data-bind*=  children]')?.textContent) ?? 0;
                const infants = thn.parseNumber(document.querySelector('.hp-reservation-rooms [data-bind*= infants]')?.textContent) ?? 0;
                const priceEl = document.querySelector('.hp-price.hp-price--large')?.textContent;
                const price = thn.parseNumber(priceEl);
                const currency = thn.parseCurrency(priceEl);
                return {
                    bookingId: pinIdBookingV1,
                    dateBegin,
                    dateEnd,
                    adults,
                    children: children + infants,
                    currency,
                    price,
                };
            }
            // booking data trough price v2
            if (pinIdBookingElmsV2.length) {
                const data = pinIdBookingElmsV2.map((value, index) => {
                    const bookingId = value.textContent;
                    if (!bookingId) {
                        return {
                            set: false,
                        };
                    }
                    const sectionsContentEls = Array.from(document.querySelectorAll('.bookwize-step4-content>div>section:not(.no-padding)'));
                    const dateBegin = sectionsContentEls[index]?.querySelector('.bookwize-step4-inner [data-bind*= checkIn]')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                    const dateEnd = sectionsContentEls[index]?.querySelector('.bookwize-step4-inner [data-bind*= checkOut]')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                    const adults = thn.parseNumber(sectionsContentEls[index]?.querySelector('.bookwize-reservation-room-inner-text [data-bind*= adults]')?.textContent);
                    const children = thn.parseNumber(sectionsContentEls[index]?.querySelector('.bookwize-reservation-room-inner-text [data-bind*= children]')?.textContent) ?? 0;
                    const infants = thn.parseNumber(sectionsContentEls[index]?.querySelector('.bookwize-reservation-room-inner-text [data-bind*= infants]')?.textContent) ?? 0;
                    const priceEl = sectionsContentEls[index]?.querySelector('.bookwize-price [data-bind*= totalCost]')?.textContent;
                    const price = thn.parseNumber(priceEl);
                    const currency = thn.parseCurrency(priceEl);
                    return {
                        bookingId,
                        dateBegin,
                        dateEnd,
                        adults,
                        children: children + infants,
                        price,
                        currency,
                    };
                });
                return data;
            }
            return {
                set: false,
            };
        },
    };
};

export { factory };
